<template>
  <v-container
    fluid
    pa-5
    class="scrollable-container"
    :style="{ paddingBottom: bottomPadding }"
  >
    <div class="table-wrapper d-flex align-center">
      <v-table flat class="no-borders">
        <tbody>
          <tr>
            <td class="text-left">
              <h1 class="text-h5 font-weight-bold mb-2">
                Get your English Indices of Deprivation 2025 Insights Report
              </h1>
              <p class="text-body-1 text-medium-emphasis mb-6">
                Choose our instant report for your recognised geography, or
                commission a Bespoke IMD Report tailored to your geographies,
                indicators and audiences.
              </p>
            </td>
          </tr>
          <tr>
            <td class="text-left">
              <v-row>
                <v-col cols="12" md="8" class="pl-0">
                  <InstantIMDReportCard />
                </v-col>
                <v-col cols="12" md="4" class="pl-0 pl-md-2">
                  <v-card
                    ref="rightCard"
                    class="right-card"
                    elevation="0"
                    :style="{
                      backgroundColor: '#51627c',
                      borderRadius: '8px',
                      minHeight: rightCardHeight,
                    }"
                  >
                    <v-card-text>
                      <p class="h3 mb-4" style="color: white !important">
                        Bespoke IMD 2025 Analysis
                      </p>
                      <p class="body-2" style="color: white !important">
                        Your areas, your boundaries, your IMD 2025 report.
                      </p>
                      <div class="price-row mt-4">
                        <span
                          class="body-2 pt-3 text-right"
                          style="color: white !important"
                        >
                          Custom analysis from
                        </span>
                        <span
                          class="price-text-bespoke"
                          style="color: white !important"
                        >
                          £1,995
                        </span>
                      </div>
                      <ul class="tick-list-bespoke mt-4">
                        <li>
                          <v-icon size="16" color="#C6ECC6" class="mr-2"
                            >mdi-check</v-icon
                          >
                          Collaborative scoping workshop to define your
                          priorities and audiences
                        </li>
                        <li>
                          <v-icon size="16" color="#C6ECC6" class="mr-2"
                            >mdi-check</v-icon
                          >
                          Flexible geography and comparator choices beyond the
                          standard options
                        </li>
                        <li>
                          <v-icon size="16" color="#C6ECC6" class="mr-2"
                            >mdi-check</v-icon
                          >
                          Custom indicators and analysis tailored to your needs
                        </li>
                        <li>
                          <v-icon size="16" color="#C6ECC6" class="mr-2"
                            >mdi-check</v-icon
                          >
                          Advanced visuals and commentary designed with your
                          stakeholders in mind
                        </li>
                        <li>
                          <v-icon size="16" color="#C6ECC6" class="mr-2"
                            >mdi-check</v-icon
                          >
                          Direct access to our data experts for support and
                          interpretation
                        </li>
                      </ul>
                      <v-row>
                        <v-col cols="12">
                          <v-btn
                            class="mt-5 mt-md-16"
                            width="100%"
                            variant="flat"
                            color="white"
                            target="_blank"
                            href="https://ocsi.uk/about/contact-us/?utm_source=on-demand&utm_medium=buttonr&utm_campaign=bespoke-IMD-2025-analysis"
                          >
                            <v-icon start color="#4D4D4D"
                              >mdi-face-agent</v-icon
                            >
                            <span style="color: #4d4d4d">
                              Talk to our Experts
                            </span>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </td>
          </tr>
          <tr>
            <td class="text-left">
              <v-row
                align="center"
                class="mt-16 text-left flex-column-reverse flex-md-row"
              >
                <v-col cols="12" md="8">
                  <h4 class="h4 mb-2">
                    Trusted by public and third-sector organisations
                  </h4>
                  <p class="body-2 mb-12 mb-sm-25">
                    As a key partner in developing the official IMD 2025, OCSI
                    brings two decades of experience in turning complex
                    neighbourhood-level data into practical insight. Since 2003,
                    we've supported evidence-based decision making across
                    sectors. Our on-demand reports use the IMD 2025 data and
                    transparent methods, giving you trusted analysis at your
                    fingertips.
                  </p>
                </v-col>
                <v-col cols="12" md="4" class="text-left text-md-right">
                  <a
                    href="https://ocsi.uk/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="@/assets/OCSILogo.png"
                      alt="OCSI Logo"
                      width="128"
                      height="auto"
                    />
                  </a>
                </v-col>
              </v-row>
              <v-row class="d-sm-none fixed-bottom-buttons">
                <v-col cols="12">
                  <v-btn
                    width="100%"
                    variant="flat"
                    color="white"
                    href="mailto:support@ocsi.co.uk?subject=Bespoke%20IMD%202025%20analysis%20enquiry"
                    class="mb-3"
                  >
                    <v-icon start color="#4D4D4D">mdi-face-agent</v-icon>
                    <span style="color: #4d4d4d"> Talk to our Experts </span>
                  </v-btn>
                </v-col>
                <v-col cols="12">
                  <v-btn
                    width="100%"
                    variant="flat"
                    color="#7AD6D9"
                    @click="OnDemandIncludedThemes()"
                    class="mb-15"
                  >
                    <v-icon start color="#3D5769">mdi-creation</v-icon>
                    <span style="color: #3d5769">
                      {{ buttonText }}
                    </span>
                  </v-btn>
                </v-col>
              </v-row>
            </td>
          </tr>
        </tbody>
      </v-table>
    </div>
  </v-container>
</template>

<script>
import InstantIMDReportCard from "@/components/InstantIMDReportCard.vue";

export default {
  name: "BuyIMDReport",
  components: {
    InstantIMDReportCard,
  },
  data: () => ({
    countries: {
      // England only for now
      eng: ["England", "English"],
      wls: ["England", "English"],
      sct: ["England", "English"],
      // wls: ["Wales", "Welsh"],
      // sct: ["Scotland", "Scottish"],
    },
    rightCardHeight: "auto",
    fixedButtonHeight: 0,
  }),
  computed: {
    buttonText() {
      return this.$vuetify.display.xs
        ? "GET YOUR REPORT"
        : "Get your Indices on Demand report";
    },
    bottomPadding() {
      // Only add padding on small screens where buttons are fixed
      if (this.$vuetify.display.sm || this.$vuetify.display.xs) {
        return `${this.fixedButtonHeight + 32}px`; // 32px base padding + button height
      }
      return "32px"; // Default padding for larger screens
    },
  },
  mounted() {
    this.matchCardHeights();
    this.measureButtonHeight();
    window.addEventListener("resize", this.matchCardHeights);
    window.addEventListener("resize", this.measureButtonHeight);

    // Send visit to analytics
    this.$axios.put("/send-analytics", {
      event: "on_demand_iod_offer_visits",
    });
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.matchCardHeights);
    window.removeEventListener("resize", this.measureButtonHeight);
  },
  methods: {
    matchCardHeights() {
      this.$nextTick(() => {
        if (this.$refs.rightCard) {
          // Only match heights on larger screens (not xs)
          if (!this.$vuetify.display.sm && !this.$vuetify.display.xs) {
            // Get height from the component's card
            const leftCard = document.querySelector(".left-card");
            if (leftCard) {
              const leftHeight = leftCard.offsetHeight;
              this.rightCardHeight = `${leftHeight}px`;
            }
          } else {
            this.rightCardHeight = "auto";
          }
        }
      });
    },
    OnDemandIncludedThemes() {
      this.$emit("button-click");
      // Fallback navigation if parent doesn't handle the event
      this.$router.push({ name: "Report outline" });
    },
    measureButtonHeight() {
      this.$nextTick(() => {
        const fixedButtons = document.querySelector(".fixed-bottom-buttons");
        if (fixedButtons) {
          this.fixedButtonHeight = fixedButtons.offsetHeight;
        }
      });
    },
  },
};
</script>

<style scoped>
.no-borders td {
  border: none !important;
  padding: 0 !important;
  overflow: hidden;
}

.no-borders tr {
  border: none !important;
}

.no-borders tbody {
  padding: 0 !important;
}

.no-borders {
  padding: 0 !important;
  margin: 0 auto !important;
  max-width: 1024px;
}

.h1 {
  color: #4d4d4d !important;
  /* Headings/H1 */
  font-family: Inter !important;
  font-size: 24px !important;
  font-style: normal !important;
  font-weight: 600 !important;
  line-height: normal !important;
}
.h3 {
  color: #4d4d4d !important;
  /* Headings/H3 */
  font-family: Inter !important;
  font-size: 18px !important;
  font-style: normal !important;
  font-weight: 600 !important;
  line-height: normal !important;
}
.h4 {
  color: #4d4d4d !important;
  /* Body/Semi-bold */
  font-family: Inter !important;
  font-size: 16px !important;
  font-style: normal !important;
  font-weight: 600 !important;
  line-height: normal !important;
}
.body-1 {
  color: #4d4d4d !important;
  /* Body/Regular */
  font-family: Inter !important;
  font-size: 16px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: normal !important;
}
.body-2 {
  color: #4d4d4d !important;
  align-self: stretch !important;
  /* Description/Regular */
  font-family: Inter !important;
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: normal !important;
}
.subHeaderText {
  width: 100%;
  max-width: 730px;
}

/* Prevent horizontal scroll in table cells */
.no-borders .v-row {
  margin: 0 !important;
}

.no-borders .v-col {
  padding: 8px !important;
}

.no-borders .v-card {
  width: 100%;
  box-sizing: border-box;
}

.price-text-bespoke {
  color: var(--Common-White, #fff) !important;
  font-family: Inter !important;
  font-size: 24px !important;
  font-style: normal !important;
  font-weight: 700 !important;
  line-height: normal !important;
}

/* Price row flexbox */
.price-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Bespoke tick list */
.tick-list-bespoke {
  list-style: none;
  padding: 0;
  margin: 0;
}

.tick-list-bespoke li {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
  font-family: Inter;
  font-size: 14px;
  color: white;
}

/* Scrollable container */
.scrollable-container {
  padding-top: 32px;
  padding-bottom: 32px;
  height: 95vh;
  overflow-y: auto;
  overflow-x: hidden;
}

/* Table wrapper for vertical centering */
.table-wrapper {
  min-height: 100%;
  width: 100%;
}

/* Fixed bottom buttons for small screens */
.fixed-bottom-buttons {
  position: fixed !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  z-index: 1000 !important;
  background: white !important;
  padding: 16px !important;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1) !important;
}

/* Fix button text wrapping */
.v-btn span {
  white-space: normal !important;
  word-wrap: break-word !important;
  max-width: 100% !important;
}
</style>
